import { HttpRequest, HttpResponse } from '@angular/common/http';
import { randomId } from '../functions';

export class BulkFileUploadMockService {
  /**
   * Mocks the portal bulk upload submission.
   *
   * POST /bulk-file-uploads
   * body: { attachmentIds: string[] }
   */
  public createBulkFileUpload(request: HttpRequest<any>): HttpResponse<any> {
    const attachmentIds = request.body?.attachmentIds ?? [];

    return new HttpResponse({
      status: 200,
      body: {
        bulkUploadDocumentId: randomId(),
        uploadedFileCount: attachmentIds.length,
      },
    });
  }
}
